export default __webpack_public_path__ + "static/media/generate-cat-button.99d1567e.svg";